import {createContext} from 'react';

const FormStateNode = createContext({
    node: null,
    response: null,
    setResponse: () => {},
});
FormStateNode.displayName = 'FormStateNode';

export default FormStateNode;
